import type { PublicPetitionWizardDraft } from '../../../types/publicPetitionCaseRequest';
import { todayIsoDateLocal } from '../../../utils/caseFieldValidation';

export function isHighUrgencyLevel(name: string): boolean {
  return name.trim().toLowerCase().includes('high');
}

export function resolveUrgencyLevelName(
  draft: Pick<PublicPetitionWizardDraft, 'urgencyLevelId' | 'urgencyLevelName'>,
  urgencyLevels: ReadonlyArray<{ id: string; name: string }> = [],
): string {
  const fromDraft = draft.urgencyLevelName.trim();
  if (fromDraft) return fromDraft;
  return urgencyLevels.find((u) => u.id === draft.urgencyLevelId)?.name?.trim() ?? '';
}

export function isPublicPetitionUrgencyJustificationRequired(
  draft: Pick<PublicPetitionWizardDraft, 'urgencyLevelId' | 'urgencyLevelName'>,
  urgencyLevels: ReadonlyArray<{ id: string; name: string }> = [],
): boolean {
  return isHighUrgencyLevel(resolveUrgencyLevelName(draft, urgencyLevels));
}

export function minDeadlineDateForPublicPetition(): string {
  return todayIsoDateLocal();
}

export const MAX_NUMBER_OF_RESPONDENTS_DIGITS = 10;

export function onlyDigitsMax(value: string, maxDigits: number): string {
  return value.replace(/[^\d]/g, '').slice(0, maxDigits);
}

export function numberOfRespondentsError(value: string): string | undefined {
  const digits = value.trim();
  if (!digits) return undefined;
  if (!/^\d+$/.test(digits)) return 'Number of respondents must contain digits only.';
  if (digits.length > MAX_NUMBER_OF_RESPONDENTS_DIGITS) {
    return `Number of respondents must be at most ${MAX_NUMBER_OF_RESPONDENTS_DIGITS} digits.`;
  }
  return undefined;
}
